// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.identify-body {
    background-color: var(--container-bg-color);
    height: 100%;
    display: flex;
    flex-direction: column;
}

span.identify-body-message {
    padding: 0.25em;
}

div.identify-body div.identify-results-container {
    overflow-y: auto;
    flex: 1 1 50%;
    min-height: 0;
    background-color: var(--list-bg-color);
    border: 1px solid var(--border-color);
    padding: 0.25em;
    margin-bottom: 0.25em;
    font-size: small;
}

div.identify-layer-expandable {
    position: relative;
    margin-left: 1em;
}

div.identify-layer-expandable > div.identify-layer-entries {
    display: none;
}

div.identify-layer-expanded > div.identify-layer-entries {
    display: block;
}

div.identify-layer-expandable:before {
    content: "";
    border-color: transparent var(--text-color);
    border-width: 0.35em 0 0.35em 0.45em;
    border-style: solid;
    display: block;
    height: 0;
    width: 0;
    left: -1em;
    top: 0.3em;
    position: absolute;
}

div.identify-layer-expanded:before {
    border-color: var(--text-color) transparent;
    border-width: 0.45em 0.35em 0 0.35em;
    top: 0.4em;
}

div.identify-layer-entries {
    padding: 0.25em 0.25em 0.25em 1em;
}

div.identify-result-entry {
    display: flex;
}

div.identify-result-entry span.clickable {
    cursor: pointer;
}

div.identify-result-entry span.active {
    font-weight: bold;
}

div.identify-result-entry > span:first-child {
    flex: 1 1 auto;
}

div.identify-result-entry span.identify-remove-result,
div.identify-result-entry span.identify-export-result {
    margin: 0 0.25em;
    color: var(--border-color);
    cursor: pointer;
    visibility: hidden;
    font-size: large;
    flex: 0 0 auto;
}

div.identify-result-entry:hover > span.identify-remove-result,
div.identify-result-entry:hover > span.identify-export-result {
    visibility: visible;
}

div.identify-body div.identify-flat-results-list {
    overflow: auto;
    flex: 1 1 auto;
}

div.identify-body .identify-result-tree-frame {
    flex: 1 1 50%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    border: 1px solid var(--border-color);
}

div.identify-body .identify-result-frame-normal {
    margin-top: 0.25em;
    border: 1px solid var(--border-color);
}

div.identify-body .identify-result-frame-highlighted {
    margin-top: 0.25em;
    border: 1px solid var(--color-active);
}

div.identify-body .identify-result-title {
    background-color: var(--list-section-bg-color);
    padding: 0.25em;
    font-weight: bold;
    flex: 0 0 auto;
    font-size: small;
    display: flex;
    align-items: center;
}

div.identify-body .identify-result-title > span:not(.icon) {
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
}

div.identify-body .identify-result-title > span.icon {
    flex: 0 0 auto;
}

div.identify-body .identify-result-title > span:not(:first-child) {
    margin-left: 0.5em;
}

div.identify-body .identify-result-title > span.icon:hover {
    color: var(--text-color-hover);
}

div.identify-body .identify-result-tree-frame > div.identify-result-container {
    overflow-y: auto;
}

div.identify-body .identify-result-box {
    border: 0;
    background-color: var(--list-bg-color);
    font-size: small;
    width: 100%;
    flex: 1 1 auto;
    min-width: 0;
    min-height: 0;
    margin: 0;
    overflow: auto;
}

div.identify-body table.attribute-list {
    width: 100%;
    table-layout: fixed;
}

div.identify-body table.attribute-list > tbody > tr:nth-child(even) {
    background-color: var(--list-item-bg-color-even);
}

div.identify-body table.attribute-list td {
    overflow: hidden;
    vertical-align: top;
    text-overflow: ellipsis;
}

div.identify-body table.attribute-list td:first-child {
    padding-left: 0.25em;
}

div.identify-body table.attribute-list td:last-child {
    padding-right: 0.25em;
}

div.identify-body table.attribute-list td.ellipsis {
    white-space: nowrap;
}

div.identify-body td.identify-attr-title {
    min-width: 10ch;
    width: 40%;
    padding-right: 1em;
}

div.identify-body td.identify-attr-value {
    width: 60%;
}

div.identify-body td.identify-attr-value > a > img {
    max-width: 100%;
}

div.identify-body div.identify-buttonbox {
    margin-top: 0.5em;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
}

div.identify-body div.identify-selectbox {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
}

select:focus {
outline: none;
}

div.identify-body table.identify-attr-subtable {
    width: 100%;
}

div.identify-body table.identify-attr-subtable > tbody > tr:nth-child(even) {
    background-color: #F0F0F0;
}

div.identify-body td.identify-attr-spacer {
    height: 2px;
    background-color: var(--list-section-bg-color);
}

span.identify-buttonbox-spacer {
    flex: 1 1 auto;
}

div.identify-body div.identify-result-feature-report-frame {
    padding: 0.25em 0.5em;
    font-size: small;
    display: flex;
    align-items: center;
}

div.identify-body div.identify-result-feature-report-frame > div.spinner {
    width: 1em;
    height: 1em;
    margin-left: 0.5em;
}
`, "",{"version":3,"sources":["webpack://./components/style/IdentifyViewer.css"],"names":[],"mappings":"AAAA;IACI,2CAA2C;IAC3C,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sCAAsC;IACtC,qCAAqC;IACrC,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,2CAA2C;IAC3C,oCAAoC;IACpC,mBAAmB;IACnB,cAAc;IACd,SAAS;IACT,QAAQ;IACR,UAAU;IACV,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,oCAAoC;IACpC,UAAU;AACd;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,8CAA8C;IAC9C,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,sCAAsC;IACtC,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;AACA,aAAa;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,8CAA8C;AAClD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB","sourcesContent":["div.identify-body {\n    background-color: var(--container-bg-color);\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\nspan.identify-body-message {\n    padding: 0.25em;\n}\n\ndiv.identify-body div.identify-results-container {\n    overflow-y: auto;\n    flex: 1 1 50%;\n    min-height: 0;\n    background-color: var(--list-bg-color);\n    border: 1px solid var(--border-color);\n    padding: 0.25em;\n    margin-bottom: 0.25em;\n    font-size: small;\n}\n\ndiv.identify-layer-expandable {\n    position: relative;\n    margin-left: 1em;\n}\n\ndiv.identify-layer-expandable > div.identify-layer-entries {\n    display: none;\n}\n\ndiv.identify-layer-expanded > div.identify-layer-entries {\n    display: block;\n}\n\ndiv.identify-layer-expandable:before {\n    content: \"\";\n    border-color: transparent var(--text-color);\n    border-width: 0.35em 0 0.35em 0.45em;\n    border-style: solid;\n    display: block;\n    height: 0;\n    width: 0;\n    left: -1em;\n    top: 0.3em;\n    position: absolute;\n}\n\ndiv.identify-layer-expanded:before {\n    border-color: var(--text-color) transparent;\n    border-width: 0.45em 0.35em 0 0.35em;\n    top: 0.4em;\n}\n\ndiv.identify-layer-entries {\n    padding: 0.25em 0.25em 0.25em 1em;\n}\n\ndiv.identify-result-entry {\n    display: flex;\n}\n\ndiv.identify-result-entry span.clickable {\n    cursor: pointer;\n}\n\ndiv.identify-result-entry span.active {\n    font-weight: bold;\n}\n\ndiv.identify-result-entry > span:first-child {\n    flex: 1 1 auto;\n}\n\ndiv.identify-result-entry span.identify-remove-result,\ndiv.identify-result-entry span.identify-export-result {\n    margin: 0 0.25em;\n    color: var(--border-color);\n    cursor: pointer;\n    visibility: hidden;\n    font-size: large;\n    flex: 0 0 auto;\n}\n\ndiv.identify-result-entry:hover > span.identify-remove-result,\ndiv.identify-result-entry:hover > span.identify-export-result {\n    visibility: visible;\n}\n\ndiv.identify-body div.identify-flat-results-list {\n    overflow: auto;\n    flex: 1 1 auto;\n}\n\ndiv.identify-body .identify-result-tree-frame {\n    flex: 1 1 50%;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid var(--border-color);\n}\n\ndiv.identify-body .identify-result-frame-normal {\n    margin-top: 0.25em;\n    border: 1px solid var(--border-color);\n}\n\ndiv.identify-body .identify-result-frame-highlighted {\n    margin-top: 0.25em;\n    border: 1px solid var(--color-active);\n}\n\ndiv.identify-body .identify-result-title {\n    background-color: var(--list-section-bg-color);\n    padding: 0.25em;\n    font-weight: bold;\n    flex: 0 0 auto;\n    font-size: small;\n    display: flex;\n    align-items: center;\n}\n\ndiv.identify-body .identify-result-title > span:not(.icon) {\n    flex: 1 1 auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\ndiv.identify-body .identify-result-title > span.icon {\n    flex: 0 0 auto;\n}\n\ndiv.identify-body .identify-result-title > span:not(:first-child) {\n    margin-left: 0.5em;\n}\n\ndiv.identify-body .identify-result-title > span.icon:hover {\n    color: var(--text-color-hover);\n}\n\ndiv.identify-body .identify-result-tree-frame > div.identify-result-container {\n    overflow-y: auto;\n}\n\ndiv.identify-body .identify-result-box {\n    border: 0;\n    background-color: var(--list-bg-color);\n    font-size: small;\n    width: 100%;\n    flex: 1 1 auto;\n    min-width: 0;\n    min-height: 0;\n    margin: 0;\n    overflow: auto;\n}\n\ndiv.identify-body table.attribute-list {\n    width: 100%;\n    table-layout: fixed;\n}\n\ndiv.identify-body table.attribute-list > tbody > tr:nth-child(even) {\n    background-color: var(--list-item-bg-color-even);\n}\n\ndiv.identify-body table.attribute-list td {\n    overflow: hidden;\n    vertical-align: top;\n    text-overflow: ellipsis;\n}\n\ndiv.identify-body table.attribute-list td:first-child {\n    padding-left: 0.25em;\n}\n\ndiv.identify-body table.attribute-list td:last-child {\n    padding-right: 0.25em;\n}\n\ndiv.identify-body table.attribute-list td.ellipsis {\n    white-space: nowrap;\n}\n\ndiv.identify-body td.identify-attr-title {\n    min-width: 10ch;\n    width: 40%;\n    padding-right: 1em;\n}\n\ndiv.identify-body td.identify-attr-value {\n    width: 60%;\n}\n\ndiv.identify-body td.identify-attr-value > a > img {\n    max-width: 100%;\n}\n\ndiv.identify-body div.identify-buttonbox {\n    margin-top: 0.5em;\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n}\n\ndiv.identify-body div.identify-selectbox {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n}\n\nselect:focus {\noutline: none;\n}\n\ndiv.identify-body table.identify-attr-subtable {\n    width: 100%;\n}\n\ndiv.identify-body table.identify-attr-subtable > tbody > tr:nth-child(even) {\n    background-color: #F0F0F0;\n}\n\ndiv.identify-body td.identify-attr-spacer {\n    height: 2px;\n    background-color: var(--list-section-bg-color);\n}\n\nspan.identify-buttonbox-spacer {\n    flex: 1 1 auto;\n}\n\ndiv.identify-body div.identify-result-feature-report-frame {\n    padding: 0.25em 0.5em;\n    font-size: small;\n    display: flex;\n    align-items: center;\n}\n\ndiv.identify-body div.identify-result-feature-report-frame > div.spinner {\n    width: 1em;\n    height: 1em;\n    margin-left: 0.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
